import type { LocationType } from "@/features/locations/types";

export const LOCATION_TYPES: { value: LocationType; label: string }[] = [
  { value: "yard", label: "Yard" },
  { value: "shed", label: "Shed" },
  { value: "bay", label: "Bay" },
  { value: "bin", label: "Bin" },
  { value: "floor", label: "Floor" },
  { value: "other", label: "Other" },
];

export function labelFor<T extends string>(
  options: { value: T; label: string }[],
  value: T | string | null | undefined,
) {
  if (!value) return "—";
  return options.find((o) => o.value === value)?.label ?? value;
}
